import { StepContainerProps } from './StepContainer.types';
import * as S from './StepContainer.styles';

const StepContainer = (props: StepContainerProps): JSX.Element => <S.Container {...props} />;

export default StepContainer;
